/**
 * Convert a File (image) to a 256x256 cropped JPEG data URI (quality 0.85).
 * Returns a Promise<string> or rejects on error.
 */
export function fileToAvatarDataURI(file, size = 256, quality = 0.85) {
  return new Promise((resolve, reject) => {
    if (!file) return reject(new Error("Sin archivo"));
    if (!file.type.startsWith("image/")) return reject(new Error("Selecciona una imagen"));
    if (file.size > 8 * 1024 * 1024) return reject(new Error("Imagen demasiado grande (máx 8MB)"));
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error || new Error("No se pudo leer la imagen"));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("No se pudo decodificar la imagen"));
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext("2d");
        // Center-crop to square
        const min = Math.min(img.width, img.height);
        const sx = (img.width - min) / 2;
        const sy = (img.height - min) / 2;
        ctx.fillStyle = "#FFFFFF";
        ctx.fillRect(0, 0, size, size);
        ctx.drawImage(img, sx, sy, min, min, 0, 0, size, size);
        try {
          resolve(canvas.toDataURL("image/jpeg", quality));
        } catch (e) { reject(e); }
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}
